import React, { useEffect, useState } from 'react';
import { Filter,maxLength, minLength, SearchInput, SelectInput, DateInput,useNotify,SelectArrayInput,ReferenceArrayInput } from 'react-admin';
import {  modePayementFiltre,deviseFiltre,json,has_role,getAgentListByRole } from '../references';
//import _ from 'lodash'
const FiltreSolde =props=> {
    const notify = useNotify();
    const [listUserByRole, setListUserByRole] = useState();
   // const [listExpManager, setListExpManager] = useState();
    const { permissions } = props;


    useEffect(() => {
              
        fetch(process.env.REACT_APP_URL+'/user/getUserByRoles', { method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data.error){
                notify(data.message, 'warning');
                setListUserByRole([]);
            } else setListUserByRole(data);
        }).catch((e) => {
            notify("Erreur lors du processus de récupération de la liste des agents !", 'warning')
        });
        //setListExpManager();
        //console.log(listExpManager)
    }, []);

    //console.log(listExpManager)

    return (
        <Filter {...props} >
            <SearchInput source="code" alwaysOn  validate={[minLength(5),maxLength(8)]} />
            <DateInput source="start_date" label="Date début"  alwaysOn />
            <DateInput source="end_date" label="Date fin"  alwaysOn />
            <SelectInput
                source="mode"
                label="Mode payement" 
                choices={modePayementFiltre}
            />
             <SelectInput
                source="devise"
                label="Devise" 
                choices={deviseFiltre}
            />

            {
            has_role(permissions,'ROLE_MANAGER')  ?   
                <SelectArrayInput
                    source="user_exp_id"
                    label="Agent exp France" 
                    choices={getAgentListByRole('ROLE_MANAGER',listUserByRole).concat(getAgentListByRole('ROLE_AG_EXP_AERIEN_FR',listUserByRole))}
                    style={{minWidth:170}}
                />
            :null
            }

            {
            has_role(permissions,'ROLE_MANAGER')  ?   
          
                <SelectArrayInput
                    source="user_dest_id"
                    label="Agent dest Guinée" 
                    choices={getAgentListByRole('ROLE_AG_EXP_AERIEN_GUI',listUserByRole)}
                    style={{minWidth:170}}
                />
            
            :null
            }

           
        </Filter>
    );

    
}

export default FiltreSolde;